













































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import GoodsSelect from '@/components/goods-select/index.vue'
import RewardPointGoodsSelect from '@/components/rewardPoint-goods-select/index.vue'
import PromotionActivityApi from '@/api/marketing/promotionActivity/index'
import GoodsApi from '@/api/goods/list'
import BrandApi from '@/api/goods/brand/index'
@Component({
  components: {
    GoodsSelect,
    RewardPointGoodsSelect,
  },
})
export default class ProductFilter extends Vue {
  @Prop({
    type: Object,
    default: () => {
      return {
        scope: 'condition',
        customProduct: false,
        brands: [],
        categories: [],
        years: [],
        season: [],
        price: {
          min: 0,
          max: 0,
        },
        discount: {
          min: 0,
          max: 0,
        },
        productIds: [],
      }
    },
  })
  formItem!: any

  @Prop({
    type: String,
    default: '',
  })
  source!: string

  @Prop({
    type: Boolean,
    default: true,
  })
  isAdd!: boolean

  id: string = ''
  // source: string = "";

  pager = {
    total: 0,
    pageIndex: 1,
    pageSize: 50,
  }

  categoryOptions: any[] = []
  get tempColumn() {
    let columns: any[] = [
      {
        type: 'selection',
        width: 60,
        align: 'center',
      },
      {
        title: '商品名称',
        width: 450,
        key: 'productName',
      },
      {
        title: '货号',
        key: 'productCode',
      },
      {
        title: '操作',
        width: 100,
        slot: 'action',
      },
    ]
    if (
      this.source === 'preSales' ||
      this.source === 'group' ||
      this.source === 'secKill' ||
      this.source === 'limitRewardPointExchange'
    ) {
      if (this.source === 'preSales') {
        columns.splice(3, 0, {
          title: '预售价',
          key: 'price',
          render: (h, params) => {
            return h('InputNumber', {
              props: {
                value: this.productList[params.index].price,
                min: 0,
              },
              on: {
                'on-change': (event: number) => {
                  this.productList[params.index].price = event
                },
              },
            })
          },
        })
      } else {
        columns.splice(3, 0, {
          title: '售价',
          key: 'price',
        })
      }
      columns.splice(4, 0, {
        title: '活动价',
        key: 'promotionPrice',
        render: (h, params) => {
          return h('InputNumber', {
            props: {
              value: this.productList[params.index].promotionPrice,
              min: 0,
            },
            on: {
              'on-change': (event: number) => {
                this.productList[params.index].promotionPrice = event
              },
            },
          })
        },
        renderHeader: (h, params) => {
          let title
          switch (this.source) {
            case 'preSales':
              title = '预售定金'
              break
            case 'group':
              title = '拼团价'
              break
            case 'secKill':
              title = '秒杀价'
              break
            case 'limitRewardPointExchange':
              title = '兑换价'
              break
            default:
              title = '活动价'
              break
          }
          return h('span', {}, [title])
        },
      });
      if(this.source === 'secKill') {
        columns.splice(5, 0, {
          title: '限购数量',
          key: 'limit',
          render: (h, params) => {
            return h('InputNumber', {
              props: {
                value: this.productList[params.index].limit,
                min: 0,
              },
              on: {
                'on-change': (event: number) => {
                  this.productList[params.index].limit = event
                },
              },
            })
          },
        });
      }
      if (this.source === 'limitRewardPointExchange') {
        columns.splice(5, 0, {
          title: '限时兑换积分',
          key: 'rewardPoint',
          render: (h, params) => {
            return h('InputNumber', {
              props: {
                value: this.productList[params.index].rewardPoint,
                min: 0,
              },
              on: {
                'on-change': (event: number) => {
                  this.productList[params.index].rewardPoint = event
                },
              },
            })
          },
        })
      }
      // if (this.source === 'secKill') {
      //   columns.splice(5, 0, {
      //     title: '限购数量',
      //     key: 'limit',
      //     render: (h, params) => {
      //       return h('InputNumber', {
      //         props: {
      //           value: this.formItem.productIds[params.index].limit,
      //           min: 0
      //         },
      //         on: {
      //           'on-change': (event: number) => {
      //             this.formItem.productIds[params.index].limit = event
      //           }
      //         }
      //       })
      //     }
      //   })
      // }
    }
    return columns
  }
  brands: any[] = []
  years: any[] = [{ name: '2017', value: '2017' }, { name: '2018', value: '2018' }, { name: '2019', value: '2019' }]
  seasons: any[] = [
    { name: '春', value: '春' },
    { name: '夏', value: '夏' },
    { name: '秋', value: '秋' },
    { name: '春夏', value: '春夏' },
    { name: '秋冬', value: '秋冬' },
  ]
  get selectedItems() {
    return this.formItem.productIds.map((x) => x.productId)
  }
  get categoriesValues() {
    return this.formItem.categories.map((x) => x.value)
  }
  radioChange(e) {
    console.log(e)
  }
  categoriesOnChange(e) {
    var result = this.categoryOptions
      .filter((x) => e.indexOf(x.id) > -1)
      .map((x) => {
        return {
          name: x.fullName,
          value: x.id,
        }
      })
    this.formItem.categories = result
  }
  get brandsValue() {
    return this.formItem.brands.map((x) => String(x.value))
  }
  brandsOnChange(e) {
    var result = this.brands.filter((x) => e.indexOf(x.value) > -1)
    this.formItem.brands = result
  }
  get yearsValue() {
    return this.formItem.years.map((x) => x.value)
  }
  yearsOnChange(e) {
    var result = this.years.filter((x) => e.indexOf(x.value) > -1)
    this.formItem.years = result
  }
  get seasonsValue() {
    return this.formItem.season.map((x) => x.value)
  }
  get showScope() {
    return !(
      this.source === 'preSales' ||
      this.source === 'group' ||
      this.source === 'secKill' ||
      this.source === 'limitRewardPointExchange'
    )
  }
  get productList() {
    var offset = (this.pager.pageIndex - 1) * this.pager.pageSize
    return this.formItem.productIds.slice(offset, offset + this.pager.pageSize)
  }
  onPageChange(current) {
    this.pager.pageIndex = current
  }
  seasonsOnChange(e) {
    var result = this.seasons.filter((x) => e.indexOf(x.value) > -1)
    this.formItem.season = result
  }
  async created() {
    // this.id = this.$route.params.id.toString();
    // this.source = this.$route.query.source.toString();
    // console.log("product filter created", this.source);
  }
  async mounted() {
    await this.getCategoriesAll()
    await this.getBrands()
    // await this.loadProductFilter();
  }

  @Watch('source', { immediate: true })
  watchSource() {
    console.log('watch', this.source)
    if (this.isAdd) {
      if (
        this.source === 'preSales' ||
        this.source === 'group' ||
        this.source === 'secKill' ||
        this.source === 'limitRewardPointExchange'
      ) {
        this.formItem.scope = 'product'
      } else {
        this.formItem.scope = 'condition'
      }
    }
    this.pager.total = this.formItem.productIds.length
  }
  async loadProductFilter() {
    await PromotionActivityApi.getProductFilter(this.id).then((res) => {
      if (res.data !== '') {
        this.formItem = res.data
      }
    })
  }
  async getCategoriesAll() {
    await GoodsApi.getCategoriesAll().then((res) => {
      if (res.data.items) {
        this.categoryOptions = res.data.items
      }
    })
  }
  async getBrands() {
    await BrandApi.getAll().then((res) => {
      if (res.data.items) {
        this.brands = res.data.items.map((t) => {
          return { value: t.id.toString(), name: t.name }
        })
      }
    })
  }
  goodsOnChange(list, type) {
    switch (type) {
      case 'selectGoods':
        console.log('选择商品时候', list)
        if (this.source === 'limitRewardPointExchange') {
          this.formItem.productIds = this.formItem.productIds.concat(
            list.map((t) => {
              return {
                productId: t.id,
                pictureUrl: t.pictureUrl,
                productName: t.productName,
                brandName: t.brandName,
                productCode: t.productCode,
                marketPrice: t.marketPrice,
                price: t.price,
                promotionPrice: t.price,
                rewardPoint: t.rewardPoint,
                limit: 0,
                displayOrder: 0,
              }
            })
          )
        } else {
          this.formItem.productIds = this.formItem.productIds.concat(
            list.map((t) => {
              return {
                productId: t.id,
                pictureUrl: t.pictureUrl,
                productName: t.name,
                brandName: t.brandName,
                productCode: t.code,
                marketPrice: t.marketPrice,
                price: t.price,
                promotionPrice: t.price,
                limit: 0,
                displayOrder: 0,
              }
            })
          )
        }
        break
      case 'uploadGoods':
        if (this.source === 'limitRewardPointExchange') {
          this.formItem.productIds = this.formItem.productIds.concat(list)
        } else {
          this.formItem.productIds = this.formItem.productIds.concat(list)
        }
        break
      default:
        break
    }
  }
  removeProduct(index: number) {
    this.formItem.productIds.splice(index, 1)
  }
  batchRemove() {
    this.$Modal.confirm({
      title: '确定要删除选中的商品吗?',
      onOk: () => {
        var selected = (this.$refs.selection as any).getSelection()
        if (selected.length <= 0) {
          return
        }
        selected.forEach((element) => {
          var index = this.formItem.productIds.findIndex((x) => x.productId == element.productId)
          this.formItem.productIds.splice(index, 1)
        })
      },
    })
  }
  save() {
    this.$emit('on-submit')
    // PromotionActivityApi.updateProductFilter(this.id, this.formItem).then(
    //   res => {
    //     this.$Message.success("保存成功");
    //     this.$router.push({
    //       name: this.source
    //     });
    //   }
    // );
  }
}
